import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Directive({
  selector: '[ngxPreventMultipleClicks]'
})
export class PreventMultipleClicksDirective {

  @Input() debounceDelayTime: number = 500; 
  @Output() onDebouncedClick = new EventEmitter();

  private clicks = 0;
  private timeout: any;

  @HostListener('click', ['$event'])
  clickEvent(event: Event): void {  
    this.clicks++;

    if (this.clicks === 1) { 
      this.timeout = setTimeout(() => {
        this.onDebouncedClick.emit(event);
        this.clicks = 0;
      }, this.debounceDelayTime);
    }
  }

}
